import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Eye } from "lucide-react";
import { ProductView } from "@/components/ProductView";
import { api } from "@/lib/api";

export default function AdminProductPreview() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    api.get(`/admin/products/${id}`).then((r) => {
      const p = r.data;
      p.variants = (p.variants || [])
        .filter((v) => v.active)
        .map((v) => ({ ...v, effective_price_pence: v.price_pence != null ? v.price_pence : p.price_pence + (v.price_delta_pence || 0) }));
      setProduct(p);
    });
  }, [id]);

  if (!product) {
    return <p className="text-sm text-cream-muted" data-testid="preview-loading">Loading…</p>;
  }

  return (
    <div data-testid="admin-product-preview-page">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber-500/50 bg-amber-500/10 p-4" data-testid="preview-banner">
        <p className="flex items-center gap-2 text-sm font-semibold text-amber-200">
          <Eye className="h-4 w-4" aria-hidden="true" />
          Preview — {product.active && !product.archived ? "this product is live in the shop" : "customers cannot see this product"}
        </p>
        <Link to={`/admin/products/${id}`} className="text-xs font-bold text-amber-200 underline" data-testid="preview-back-to-edit">
          Back to editor
        </Link>
      </div>
      <ProductView product={product} preview />
    </div>
  );
}
